/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsListPipelinesResponse {
    getFixupPrototypeFunction() { return AzureDevOpsListPipelinesResponse.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsListPipelinesResponse>): AzureDevOpsListPipelinesResponse {
        let obj = Object.assign(new AzureDevOpsListPipelinesResponse(), model);
        AzureDevOpsListPipelinesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsListPipelinesResponse>): AzureDevOpsListPipelinesResponse {
        if (!model) return null;
        return AzureDevOpsListPipelinesResponse.newInstance(<AzureDevOpsListPipelinesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsListPipelinesResponse) {
        if (!obj) return;

        models.AzureDevOpsListPipelinesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsListPipelinesResponse): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsListPipelinesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.pipelines) {
            for (let val of this.pipelines) {
                models.AzureDevOpsPipeline.fixupPrototype(val);
            }
        }
    }

    /**
     * List of project name
     */
    pipelines: Array<models.AzureDevOpsPipeline>;

}
